import { Box, Typography } from '@mui/material';
import { ControlModeTemplateField } from '@src/types/ControlModes';
import React from 'react';
import { FormValue } from '../../context/formReducer';
import { ConfigTextField } from '../styles';

interface StringFieldProps {
  field: ControlModeTemplateField;
  fieldValue: FormValue | undefined;
  hasError: boolean;
  errorMessage: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const StringField: React.FC<StringFieldProps> = ({
  field,
  fieldValue,
  hasError,
  errorMessage,
  handleChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <ConfigTextField
        name={field.controllerField}
        value={
          fieldValue !== undefined && fieldValue !== null
            ? fieldValue
            : (field.defaultValue ?? '')
        }
        onChange={handleChange}
        variant='outlined'
        size='small'
        error={hasError}
        slotProps={{
          htmlInput: {
            style: { textAlign: 'center' },
          },
        }}
      />
      {hasError && (
        <Typography variant='caption' color='error'>
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default StringField;
